import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { LanguageService } from '../language.service';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatButtonModule],
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent {
  languages = [
    { code: 'en', label: 'English', flag: 'assets/flags/en.jpg' },
    { code: 'fr', label: 'Français', flag: 'assets/flags/fr.jpg' },
    { code: 'it', label: 'Italiano', flag: 'assets/flags/it.jpg' },
    { code: 'de', label: 'Deutsch', flag: 'assets/flags/de.jpg' },
  ];

  currentLang = this.languageService.selectedLang;
  currentFlag = computed(() => {
    return (
      this.languages.find((l) => l.code === this.currentLang())?.flag ||
      'assets/flags/en.jpg'
    );
  });

  constructor(private languageService: LanguageService) {}

  changeLanguage(lang: string) {
    this.languageService.setLanguage(lang);
  }
}
